const axios = window.axios;
import { usermavenClient } from '@usermaven/sdk-js'
import { USERMAVEN_ENABLED, USERMAVEN_API_KEY, USERMAVEN_TRACKING_HOST } from '@/shared/const';

export default {
    install: (app, options) => {
        const isEnabled = USERMAVEN_ENABLED
        const EVENT_TYPES = {
            SIGNED_UP: 'signed_up',
            LOGGED_IN: 'logged_in',
            LOGGED_OUT: 'logged_out',
            TRIAL_STARTED: 'trial_started',
            TRIAL_ENDED: 'trial_ended',
            PLAN_UPGRADED: 'plan_upgraded',
            PLAN_DOWNGRADE: 'plan_downgraded',
            CARD_ADDED: 'card_added',
        }
        if (!isEnabled) {
            return;
        }
        
        let usermavenInstance = usermavenClient({
            // Required Configuration
            key: USERMAVEN_API_KEY,           // Your Usermaven API key
            trackingHost: 'https://' + USERMAVEN_TRACKING_HOST,  // Your tracking server URL
            
            // Optional Configuration
            autocapture: true,             // Enable automatic event capturing
            autoPageview: true,            // Automatically track page views
            randomizeUrl: false,           // Randomize URLs to avoid PII collection
            
            // Cross-domain Tracking ( Optional )
            crossDomainLinking: true,     // Enable cross-domain tracking
            domains: 'instawp.com,instawp.io,app.instawp.io,central.app.io',       // Specify allowed domains
        })
        
        const setUpUserMaven = (user) => {
            if (!usermavenInstance) {
                return;
            }
            // Setup user
            if (!user || !user.masked_email) {
                return
            }
            const names = user.name ? user.name.split(" ") : ['', '']
            const payload = {
                id: user.id,
                email: user.masked_email,
                created_at: user.sign_up_date,
                first_name: names[0],
                last_name: names[1] ?? null,
                custom: {
                    plan_name: user.base_plan_name,
                    last_login_date: user.logged_in_at,
                    is_verified: user.is_verified,
                    is_paid: user.is_paid,
                    team_plan: user.team_base_plan_name,
                },
            }
            payload.id = payload?.id?.toString()
            usermavenInstance.id(payload)
            if (!user.is_usermaven_identified) {
                console.log('usermaven identified', user.masked_email);
                axios.post("/api/v2/user-maven-identified")
            }
        }
        const trackEvent = (event, payload) => {
            if (!usermavenInstance) {
                return;
            }
            usermavenInstance.track(event, payload)
        }
        const reset = () => {
            if (!usermavenInstance) {
                return;
            }
            usermavenInstance.reset(true)
        }
        if (options.user) {
            setUpUserMaven(options.user)
        }
        app.config.globalProperties.$usermaven = {
            eventTypes: EVENT_TYPES,
            setUpUserMaven: setUpUserMaven,
            trackEvent: trackEvent,
            reset: reset
        }
    }
}